import { PageInfo } from './../../../../core/models/page-info';
import { FacilityService } from './../../../../core/services/facility.service';
import { Table } from 'primeng/table';
import { AddressMaintainanceService } from './../../service/address-maintainance.service';
import { Component, OnInit, ViewChild, Injector, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { isNullOrEmpty, deepCopy, genTableTranslation, onDropdownKeydown } from 'src/app/core/utils/common-functions';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { LocationOption } from 'src/app/shared/components/model/LocationOption';


@Component({
  selector: 'laas-address-maintainance',
  templateUrl: './address-maintainance.component.html',
  styleUrls: ['./address-maintainance.component.scss'],
})
export class AddressMaintainanceComponent
  extends SessionBaseComponent
  implements OnInit
{
  isSearchFormOpen: boolean;
  isHeaderLoading: boolean;
  isImportLoading: boolean;
  isdetailLoading: boolean;
  dplChecked: boolean;
  searchForm: FormGroup;

  countryOptions: any[];
  districtOptions: any[];
  cityOptions: any[];
  districtAllOptions: any[];
  cityAllOptions: any[];
  airPortOptions: any[];
  airPortAllOptions: any[];

  pageInfo: PageInfo;
  detailPageInfo: PageInfo;
  importPageInfo: PageInfo;

  sortInfo: [{ property: string; direction: number }] | null;
  detailSortInfo: [{ property: string; direction: number }] | null;
  importSortInfo: [{ property: string; direction: number }] | null;

  tableDetailColumns: any[];

  selectedImportRows: any[];
  importAddressColumns: any[];
  importAddressValue: any[];
  importAddressRequest: any;
  isImportDialogOpen: boolean;
  customerOptions: any[];

  selectedRow: any;
  selectedDetailRows: any[];

  canEditTable: boolean;

  tableDetailValue: any[];
  dplCheckAddrData: any;
  dplCheckDOData: any;
  // 原新刪修變數
  tableValue: any[];
  tableColumns: any[];
  selectedTableColumns: any[];
  deletedGroupIdList: any[];

  cloneTableValue: any;
  previousSelectedRow: any;
  editMode: boolean;
  newRowFormat: any;
  maxRowId: any;
  tableDistrictOptions: any[];
  tableCityOptions: any[];
  tableAirportOptions: any[];
  allCountryOptions: LocationOption[] = [];
  allCityOptions: LocationOption[] = [];
  allDistrictOptions: LocationOption[] = [];

  readonly viewPermissionCode = PermissionConstants.ViewAddressMaintainSetting;
  readonly editPermissionCode = PermissionConstants.EditAddressMaintainSetting;
  readonly headerPreferenceKey: string = UserPreferenceConstants.AddressMaintainTableHeaderData;
  readonly detailPreferenceKey: string = UserPreferenceConstants.AddressMaintainTableDetailData;
  readonly importPreferenceKey: string = UserPreferenceConstants.AddressMaintainTableImportData;

  @ViewChild('addrTable') dataTable!: Table;
  currentLang: string = this.laasSetting.language;

  protected readonly onDropdownKeydown = onDropdownKeydown;

  constructor(
    private formBuilder: FormBuilder,
    private facilityService: FacilityService,
    private addressMaintainanceService: AddressMaintainanceService,
    injector: Injector
  ) {
    super(injector);

    this.isSearchFormOpen = true;
    this.isHeaderLoading = false;
    this.isImportLoading = false;
    this.isdetailLoading = false;
    this.dplChecked = true;

    this.countryOptions = [];
    this.cityOptions = [];
    this.districtOptions = [];
    this.customerOptions = [];
    this.districtAllOptions = [];
    this.cityAllOptions = [];
    this.airPortOptions = [];
    this.airPortAllOptions = [];

    this.tableDetailValue = [];
    this.importAddressValue = [];

    this.pageInfo = {
      pageSize: 5,
      pageIndex: 0,
      totalRecords: 0,
      totalPages: 0,
    };
    this.sortInfo = null;
    this.detailPageInfo = {
      pageSize: 5,
      pageIndex: 0,
      totalRecords: 0,
      totalPages: 0,
    };
    this.detailSortInfo = null;
    this.importPageInfo = {
      pageSize: 5,
      pageIndex: 0,
      totalRecords: 0,
      totalPages: 0,
    };
    this.importSortInfo = null;

    this.canEditTable = false;
    this.importAddressRequest = { consigneeKey: null, groupId: null };
    this.isImportDialogOpen = false;

    this.selectedImportRows = [];
    this.selectedDetailRows = [];

    this.searchForm = this.formBuilder.group({
      consigneeKey: null,
      searchLocation: [null], // 巢狀結構：{country, city, district}
      airport: null,
      deliveryLocalName: null,
      deliveryEngName: null,
      localAddress: null,
      engAddress: null,
      groupId: null
    });

    // 原新刪修變數
    this.tableValue = [];

    // i18n 表格
    this.tableColumns = this.tableTranslation();
    this.selectedTableColumns = this.tableColumns;
    this.tableDetailColumns = this.tableDetailTranslation();
    this.importAddressColumns = this.tableImportTranslation();
    this.cloneTableValue = [];

    // 刪除資料陣列
    this.deletedGroupIdList = [];

    this.tableCityOptions = [];
    this.tableDistrictOptions = [];
    this.tableAirportOptions = [];

    this.editMode = false;

    this.newRowFormat = {
      rowId: '',
      consigneeKey: '',
      country: null,
      city: null,
      assignmentDistrictId: null,
      deliveryToLocalName: '',
      deliveryToEngName: '',
      airport: null,
      localAddress: '',
      engAddress: '',
      groupId: null
    };
    this.previousSelectedRow = this.selectedRow;
  }

  @Input() get selectedColumns(): any[] {
    return this.selectedTableColumns;
  }

  set selectedColumns(cols: any[]) {
    this.selectedTableColumns = this.tableColumns.filter(col => cols.includes(col));
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    // permission Codes
    this.permissionCodes = (
      Object.values(this.userProfile.roles).reduce(
        (c: any, i: any) => c.concat(i.permissions),
        []
      ) as any
    ).map((x: any) => {
      return x.permissionCode;
    });

    this.addressMaintainanceService.getCustomerOptions().subscribe({
      next: (result) => {
        this.customerOptions = [...result].map((x: any) => {
          return {
            label: x.customerCode + ' - ' + x.customerName,
            value: x.customerCode,
          };
        });
      },
    });

    this.addressMaintainanceService.getAirPortAllOptions().subscribe({
      next: (result) => {
        this.airPortAllOptions = [...result].map((x: any) => {
          return {
            label: x.optionDesc,
            value: x.optionCode,
          };
        });
      },
    });


    //rbac to maintain this page
    var canInPage = this.permissionCodes.includes(this.viewPermissionCode);
    if (!canInPage) {
      //go unAuthorize
      this.routeStateService.navigateTo('/Error/unAuthorize');
    }

    this.canEditTable = this.permissionCodes.includes(this.editPermissionCode);
  }

  /**
   * 接收國家選項 - 用於查詢結果 Mapping 和表格編輯
   */
  onCountryOptionsReady(options: LocationOption[]): void {
    this.countryOptions = options;
    this.allCountryOptions = options;
    // 建立表格編輯需要的國家選項格式
    this.countryOptions = options.map(option => ({
      label: `${option.countryCode || option.value} - ${option.countryName || option.label}`,
      value: option.countryCode || option.value
    }));
  }

  /**
   * 接收城市選項 - 用於查詢結果 Mapping
   */
  onCityOptionsReady(options: LocationOption[]): void {
    this.cityAllOptions = options;
  }

  /**
   * 接收小區選項 - 用於查詢結果 Mapping
   */
  onDistrictOptionsReady(options: LocationOption[]): void {
    this.allDistrictOptions = options;
  }

  countryChange(locationData: any):void{
    this.airPortOptions = [];
    this.searchForm.controls['airport'].setValue(null);
  }

  /**
   * 位置選擇完成事件 - 可以在這裡載入機場選項
   */
  async cityChange(locationData: any): Promise<void> {
    // 如果選擇了城市，載入對應的機場選項
    if (locationData.value) {
      this.airPortOptions = await this.getAirportOptions(locationData.value);
    }
  }

    private async getAirportOptions(city: string): Promise<any[]> {
      var airPortOptions: any[] = [];
      try {
        airPortOptions = await this.addressMaintainanceService.getAirPortOptions(
          city
        );
      } catch {
        this.toastService.error('get airPort occur error');
      }
      return new Promise((resolve) => {
        resolve(
          airPortOptions.map((x: any) => {
            return {
              label: x.optionDesc,
              value: x.optionCode,
            };
          })
        );
      });
    }

    // table內dropdown需要的method
    async tableCountryChange(rowData: any): Promise<void> {
      if (!isNullOrEmpty(rowData.country)) {
        this.tableCityOptions = await this.getCityOptions(rowData.country);
      }
    }
    private async getCityOptions(country: string): Promise<any[]> {
    var cityOptions: any[] = [];
    try {
      cityOptions = await this.addressMaintainanceService.getCityOptions(
        country
      );
    } catch {
      this.toastService.error('get city occur error');
    }
    return new Promise((resolve) => {
      resolve(
        cityOptions.map((x: any) => {
          return {
            label: x.enName + ' - ' + x.name,
            value: x.seqNo,
          };
        })
      );
    });
  }

    async tableCityChange(rowData: any): Promise<void> {
      if (!isNullOrEmpty(rowData.country) && !isNullOrEmpty(rowData.city)) {
        this.tableDistrictOptions = await this.getAssignmentDistrict(rowData.country, rowData.city);
        this.tableAirportOptions = await this.getAirportOptions(rowData.city);
      }
    }

    private async getAssignmentDistrict(country: string, city: number): Promise<any[]> {
    var assignmentOptions: any[] = [];
    try {
      assignmentOptions =
        await this.addressMaintainanceService.getAssignmentDistrict(country, city);
    } catch {
      this.toastService.error('get assignment district occur error');
    }
    return new Promise((resolve) => {
      resolve(
        assignmentOptions.map((x: any) => {
          return {
            label: x.districtName,
            value: x.assignmentDistrictId,
          };
        })
      );
    });
  }


  searchBtnClick() {
    this.pageInfo.pageIndex = 0;
    this.detailPageInfo.pageIndex = 0;
    this.sendSearchRequest()
  }

  sendSearchRequest() {
    const addressSearchParams = this.createSearchParams();
    addressSearchParams.facility = this.laasSetting.facility;
    addressSearchParams.pageSize = this.pageInfo.pageSize;
    addressSearchParams.pageIndex = this.pageInfo.pageIndex;
    addressSearchParams.sortInfo = this.sortInfo;
    this.isHeaderLoading = true;
    this.isdetailLoading = true;
    this.addressMaintainanceService
      .getAddressData(addressSearchParams)
      .subscribe({
        next: (result) => {
          const pageList = result.content;
          this.tableValue = deepCopy(pageList);
          this.putRowId(this.tableValue);

          this.cloneTableValue = deepCopy(pageList);
          this.putRowId(this.cloneTableValue);

          // 重設資料
          this.resetData();

          //更改總數量資料
          this.pageInfo.totalRecords = result.totalElements;

          this.isHeaderLoading = false;
          this.isdetailLoading = false;
          this.isSearchFormOpen = false;
          // 重新抓取資料後取消編輯
          this.onRowSelect(this.tableValue[0]);

          if (this.editMode) {
            this.dataTable.cancelRowEdit(this.previousSelectedRow);
            this.editMode = !this.editMode;
          }
        },
      });
    }

  /**
   * 建立搜尋參數物件
   */
  private createSearchParams(): any {
    const searchLocation = this.searchForm.value.searchLocation;

    return {
      consigneeKey: this.searchForm.value.consigneeKey,
      country: searchLocation?.country || null,
      city: searchLocation?.city || null,
      assignmentDistrictId: searchLocation?.district || null,
      airport: this.searchForm.value.airport,
      deliveryLocalName: this.searchForm.value.deliveryLocalName,
      deliveryEngName: this.searchForm.value.deliveryEngName,
      localAddress: this.searchForm.value.localAddress,
      engAddress: this.searchForm.value.engAddress,
      groupId: this.searchForm.value.groupId,
      facility: this.laasSetting.facility,
      pageSize: this.pageInfo.pageSize,
      pageIndex: this.pageInfo.pageIndex,
      sortInfo: this.sortInfo
    };
  }

  putRowId(array: any[]) {
    let rowId = 1;
    for (const val of array) {
      val.rowId = rowId;
      rowId = rowId + 1;
    }
  }

  importBtnClick() {
    let groupIsExist = false;

    // 檢查有沒有匯入非孤兒地址的地址
    for (const row of this.selectedImportRows) {
      if (!isNullOrEmpty(row.groupId)) {
        groupIsExist = true;
        break;
      }
    }

    if (groupIsExist) {
      this.confirmationService.confirm({
        message: this.translateService.instant('AddressMaintain.Confirm.GroupIsExist'),
        header: this.translateService.instant('AddressMaintain.Confirm.Header'),
        icon: 'pi pi-info-circle',
        accept: () => {
          this.importAddress();
        },
      });
    } else {
      this.confirmationService.confirm({
        message: this.translateService.instant('AddressMaintain.Confirm.Import'),
        header: this.translateService.instant('AddressMaintain.Confirm.Header'),
        icon: 'pi pi-info-circle',
        accept: () => {
          this.importAddress();
        },
      });
    }
  }

  importAddress() {
    this.isImportLoading = true;

    this.doImport();
  }

  doImport(){
    let importAddressList = [];

    for (const row of this.selectedImportRows) {
      importAddressList.push(row.seqNo);
    }

    const importRequest = {reqSeqNoList: importAddressList,
      updateUser: this.userProfile.userName,
      importGroupId: this.importAddressRequest.groupId};

    this.addressMaintainanceService
    .doImportAddress(importRequest)
    .subscribe({
    next: () => {
      // 重新抓取資料(確保import做完)
      this.getDetailAddressData();

      this.isImportDialogOpen = false;
      this.selectedImportRows = [];
      this.toastService.success(this.translateService.instant('AddressMaintain.Toast.ImportSuccess'));
      this.isImportLoading = false;
      },
    });
  }

  tablePageChange(event: any) {
    this.pageInfo.pageSize = event.rows;
    this.pageInfo.pageIndex = event.first / this.pageInfo.pageSize;
    this.sendSearchRequest();
  }

  tableSort(event: any): void {
    this.sortInfo = [{ property: event.field, direction: event.order }];
    this.sendSearchRequest();
  }

  detailTablePageChange(event: any) {
    this.detailPageInfo.pageSize = event.rows;
    this.detailPageInfo.pageIndex = event.first / this.detailPageInfo.pageSize;
    this.getDetailAddressData();
  }

  detailTableSort(event: any): void {
    this.detailSortInfo = [{ property: event.field, direction: event.order }];
    this.getDetailAddressData();
  }

  getDetailAddressData() {
    if (this.selectedRow) {
      if (this.selectedRow.consigneeKey && this.selectedRow.groupId) {

        const addressSearchParams = {
          pageSize: this.detailPageInfo.pageSize,
          pageIndex: this.detailPageInfo.pageIndex,
          sortInfo: this.detailSortInfo,
          groupId: this.selectedRow.groupId
        };

        this.isdetailLoading = true;
        this.addressMaintainanceService
          .getDetailAddressData(addressSearchParams)
          .subscribe({
            next: (result) => {
              this.tableDetailValue = result.content;
              this.detailPageInfo.totalRecords = result.totalElements;
            },
          });
      } else {
        this.tableDetailValue = [];
      }
      this.selectedDetailRows = [];
      this.selectedImportRows = [];
      this.isdetailLoading = false;
    }
  }

  openImportDialog() {
    // 驗證資料
    if (this.isRowInvalid()) {
      return
    }

    this.isImportLoading = true;
    this.importAddressRequest.consigneeKey = this.selectedRow.consigneeKey;
    this.importAddressRequest.groupId = this.selectedRow.groupId;
    this.importAddressRequest.pageSize = this.importPageInfo.pageSize;
    this.importAddressRequest.pageIndex = this.importPageInfo.pageIndex;
    this.importAddressRequest.sortInfo = this.importSortInfo;

    this.addressMaintainanceService
      .getImportAddressData(this.importAddressRequest)
      .subscribe({
        next: (result) => {
          const pageList = result.content;
          this.importAddressValue = pageList;
          //更改總數量資料
          this.importPageInfo.totalRecords = result.totalElements;
          this.isImportLoading = false;
        },
      });
    this.isImportDialogOpen = true;
  }

  importTablePageChange(event: any) {
    this.importPageInfo.pageSize = event.rows;
    this.importPageInfo.pageIndex = event.first / this.importPageInfo.pageSize;
    this.openImportDialog();
  }

  importTableSort(event: any): void {
    this.importSortInfo = [{ property: event.field, direction: event.order }];
    this.openImportDialog();
  }

// 新刪修方法
  onRowSelect(rowData: any) {
    // 讓user重複點同一行導致unselected時一樣能選中該列
    this.selectedRow = rowData;
    // 選行流程:關閉上一行編輯模式->開啟這一行編輯模式->clone這一行資料到previousSelectedRow(這樣下次選別行才會把剛剛開啟那行關掉)
    if (this.editMode) {
      // 取得上一列更改過的值
      for (const val of this.tableValue) {
        if (this.previousSelectedRow.rowId == val.rowId) {
          this.previousSelectedRow = deepCopy(val);
        }
      }
      // DPL check
      // 偵測此列的收件公司(英文)改動是否與原本不一致
      if (this.previousSelectedRow.groupId){
        for (const val of this.cloneTableValue) {
          if (this.previousSelectedRow.rowId == val.rowId) {
            if (this.previousSelectedRow.engAddress != val.engAddress) {
              const dplCheckRow = deepCopy(this.previousSelectedRow);

              const addressSearchParams = {
                pageSize: this.detailPageInfo.pageSize,
                pageIndex: this.detailPageInfo.pageIndex,
                sortInfo: this.detailSortInfo,
                groupId: this.selectedRow.groupId
              };

              this.addressMaintainanceService.getDetailAddressData(addressSearchParams).subscribe({
                next: result =>{
                  if (result.length > 0) {
                    const addressList = [];
                    for (const val of result.content) {
                      addressList.push(val.address);
                    }
                    this.dplChecked = true;
                    this.doSwitchRow();
                  } else {
                    this.dplChecked = true;
                    this.doSwitchRow();
                  }
                }
              });

            } else {
              this.dplChecked = true;
              this.doSwitchRow();
              break;
            }
          }
        }
      }else {
        this.doSwitchRow();
      }
    } else {
      this.previousSelectedRow = deepCopy(this.selectedRow);
      this.getDetailAddressData();
    }

  }

  doSwitchRow(){
    if (!this.isRowInvalid()) {

      this.dataTable.cancelRowEdit(this.previousSelectedRow);

      // 更改選項預設值
      this.tableCountryChange(this.selectedRow);
      this.tableCityChange(this.selectedRow);

      this.dataTable.initRowEdit(this.selectedRow);

      this.previousSelectedRow = deepCopy(this.selectedRow);
    }
  }

  switchEditMode() {
    if (this.editMode) {
      // 驗證資料
      if (this.isRowInvalid()) {
        return
      }

      this.dataTable.cancelRowEdit(this.selectedRow);
      this.editMode = !this.editMode;
    } else if (this.selectedRow) {
      // 選項預設值
      this.tableCountryChange(this.selectedRow);
      this.tableCityChange(this.selectedRow);

      this.dataTable.initRowEdit(this.selectedRow);
      this.previousSelectedRow = deepCopy(this.selectedRow);
      this.editMode = !this.editMode;
    }

  }

  createNewRow() {
    // 取得上一列更改過的值
    for (const val of this.tableValue) {
      if (this.previousSelectedRow.rowId == val.rowId) {
        this.previousSelectedRow = deepCopy(val);
      }
    }
    if (!this.maxRowId) {
      if (this.tableValue.length > 0){
        this.maxRowId = this.tableValue[this.tableValue.length - 1].rowId;
      } else {
        this.maxRowId = 0;
      }
    }
    if (this.editMode) {
      // 驗證資料
      if (this.isRowInvalid()) {
        return
      }
      // 新增時建立新的dataKey

      this.maxRowId = this.maxRowId + 1;
      this.newRowFormat.rowId = this.maxRowId;
      this.dataTable.value.unshift(deepCopy(this.newRowFormat));
      this.selectedRow = this.dataTable.value[0];

      this.dataTable.cancelRowEdit(this.previousSelectedRow);
      this.dataTable.initRowEdit(this.selectedRow);
      this.previousSelectedRow = deepCopy(this.selectedRow);

    }
  }

  deleteSelectedRow() {
    this.confirmationService.confirm({
      message: this.translateService.instant('AddressMaintain.Confirm.Delete'),
      header: this.translateService.instant('AddressMaintain.Confirm.Header'),
      icon: 'pi pi-info-circle',
      accept: async () => {
        // 取得上一列更改過的值
        for (const val of this.tableValue) {
          if (this.previousSelectedRow.rowId == val.rowId) {
            this.previousSelectedRow = deepCopy(val);
          }
        }

        if (JSON.stringify(this.previousSelectedRow) != JSON.stringify(this.selectedRow)) {
          // 驗證資料
          if (this.isRowInvalid()) {
            return
          }
        }

        // 驗證是否此正規地址已有跟參考地址關聯
        if (await this.addressMaintainanceService.checkAddressIsAssociated(this.selectedRow.groupId)) {
          this.toastService.warn(this.translateService.instant('AddressMaintain.Toast.AddressIsAssociated'))
          return;
        }

        for (const x of this.tableValue) {
          if (x.rowId === this.selectedRow.rowId) {
            // 紀錄刪除列的groupId
            if(!isNullOrEmpty(this.selectedRow.groupId)){
              this.deletedGroupIdList.push(this.selectedRow.groupId)
            }
            // 刪除後關閉行編輯
            this.dataTable.cancelRowEdit(this.selectedRow);
            this.tableValue.splice(this.tableValue.indexOf(x), 1);
            // 刪除後將row指到下一行
            this.selectedRow = this.tableValue[0];
            this.previousSelectedRow = deepCopy(this.selectedRow);
            break;
          }
        }
        if (this.dplChecked == false) {
          this.dplChecked = true;
        }
      }
    });

  }

  resetTableValue() {
    this.confirmationService.confirm({
      message: this.translateService.instant('AddressMaintain.Confirm.Restore'),
      header: this.translateService.instant('AddressMaintain.Confirm.Header'),
      icon: 'pi pi-info-circle',
      accept: () => {
        this.tableValue = deepCopy(this.cloneTableValue);
        this.resetData();
        this.sendSearchRequest();
        this.toastService.success(this.translateService.instant('AddressMaintain.Toast.RestoreSuccess'))
      }
    });

  }
  saveBtnClick() {
    this.confirmationService.confirm({
      message: this.translateService.instant('AddressMaintain.Confirm.Save'),
      header: this.translateService.instant('AddressMaintain.Confirm.Header'),
      icon: 'pi pi-info-circle',
      accept: () => {
        this.saveChange();
      }
    });
  }
  saveChange(){
    let insertDataArr = [];
    let updateDataArr = [];
    // 驗證資料
    if (this.isRowInvalid()) {
      return
    }

    for (const rowVal of this.tableValue) {
      if(isNullOrEmpty(rowVal.groupId)){
        rowVal.user = this.userProfile.userName;
        insertDataArr.push(rowVal);
      }else{
        for (const cloneRowVal of this.cloneTableValue){
          if(rowVal.rowId == cloneRowVal.rowId){
            if(JSON.stringify(rowVal) != JSON.stringify(cloneRowVal)){
              rowVal.updateUser = this.userProfile.userName;
              updateDataArr.push(rowVal);
            }
          }
        }
      }
    }

    // 組裝新刪修資料
    const saveAddressVal = {newAddressValList: insertDataArr, updateAddressList: updateDataArr, deletedGroupIdList: this.deletedGroupIdList};

    this.addressMaintainanceService.saveAddressData(saveAddressVal).subscribe({
      next: result =>{
        // 還原資料
        this.resetData();
        // 重新查詢資料
        this.sendSearchRequest();
        this.toastService.success(this.translateService.instant('AddressMaintain.Toast.SaveSuccess'))
      },
      error: response =>{
        this.toastService.error(this.translateService.instant('AddressMaintain.Toast.SaveFail') + response.error.errorCode)
      }
    });
  }

  deleteDetailAddress() {
    let deleteAddressList: any[] = [];

    for (const row of this.selectedDetailRows) {
      deleteAddressList.push(row.seqNo);
    }

    if (deleteAddressList.length == 0) {
      this.toastService.warn(this.translateService.instant('Common.Toast.NoDetailsSelected'));
      return;
    }

    this.confirmationService.confirm({
      message: this.translateService.instant('AddressMaintain.Confirm.Delete'),
      header: this.translateService.instant('AddressMaintain.Confirm.Header'),
      icon: 'pi pi-info-circle',
      accept: () => {
        // 利用import的API 把GroupId設成空值
        const importRequest = {reqSeqNoList: deleteAddressList,
          updateUser: this.userProfile.userName,
          importGroupId: ""};

        this.addressMaintainanceService
        .doImportAddress(importRequest)
        .subscribe({
        next: () => {
          // 重新抓取資料(確保delete做完)
          this.getDetailAddressData();

          this.toastService.success(this.translateService.instant('AddressMaintain.Toast.DeleteSuccess'));
          },
        });
      }
    })
  }

  async doDPLCheck(addressList: any, engAddress: any, country: any) {
    for (const address of addressList){
      if (address == "" || address == null){
        return {row: engAddress, result: false};
      }
      const doData = await this.addressMaintainanceService.getDOWithAddress(address);

      if (isNullOrEmpty(doData)) {
        console.log("dplcheck do is null")
        return {row: engAddress, result: false};
      }
      const dplCheckReq = {address: engAddress, companyName: doData.consigneeCompany
        , country: country, doNo: doData.doNo};

      try{
        const checkResult = await this.addressMaintainanceService.doDPLCheck(dplCheckReq);
        if (!checkResult || checkResult.flag != "S") {
          console.log(checkResult);
          return {row: engAddress, result: false};
        }
      } catch (error) {
        return {row: engAddress, result: false};
      }
    }
    return {row: 'pass', result: true};
  }

  isRowInvalid(): boolean {
    // 取得上一列更改過的值
    for (const val of this.tableValue) {
      if (this.previousSelectedRow.rowId == val.rowId) {
        this.previousSelectedRow = deepCopy(val);
      }
    }
    if (isNullOrEmpty(this.previousSelectedRow.localAddress) && isNullOrEmpty(this.previousSelectedRow.engAddress)) {
      this.toastService.warn(this.translateService.instant('AddressMaintain.Toast.NoAddress'));
      return true;
    } else if (this.dplChecked == false) {
      this.toastService.warn(this.translateService.instant('AddressMaintain.Toast.DplFail'));
      return true;
    } else {
      return false;
    }
  }

  resetData(){
    this.dplChecked = true;
    this.deletedGroupIdList = [];
    delete this.maxRowId;
  }

  // translate table
  tableTranslation(): any[] {

    const fields = ['groupId', 'consigneeKey', 'deliveryToLocalName', 'deliveryToEngName', 'localAddress', 'engAddress', 'country',
    'city', 'assignmentDistrictId', 'airport', 'createUser', 'createDt', 'updateUser', 'updateDt'];
    const dates = ['createDt', 'updateDt'];
    const fieldSorts = fields;
    const jsons = ['AddressMaintain.MainTable.Column.GroupId',
      'AddressMaintain.MainTable.Column.ConsigneeKey', 'AddressMaintain.MainTable.Column.DeliveryToLocalName',
      'AddressMaintain.MainTable.Column.DeliveryToEngName', 'AddressMaintain.MainTable.Column.LocalAddress',
      'AddressMaintain.MainTable.Column.EngAddress', 'AddressMaintain.MainTable.Column.Country',
      'AddressMaintain.MainTable.Column.City', 'AddressMaintain.MainTable.Column.AssignmentDistrict',
      'AddressMaintain.MainTable.Column.Airport', 'AddressMaintain.MainTable.Column.CreateUser',
      'AddressMaintain.MainTable.Column.CreateDt', 'AddressMaintain.MainTable.Column.UpdateUser',
      'AddressMaintain.MainTable.Column.UpdateDt'];

      return genTableTranslation(this.translateService, fields, dates, fieldSorts, jsons);
  }

  tableImportTranslation(): any[] {

    const fields = ['address', 'consigneeCompany', 'localAddress', 'engAddress', 'country', 'city', 'assignmentDistrictId',
      'deliveryToLocalName', 'deliveryToEngName', 'airport', 'createUser', 'createDt', 'updateUser', 'updateDt'];
    const dates = ['createDt', 'updateDt'];
    const fieldSorts = fields;
    const jsons = [
      'AddressMaintain.MainTable.Column.Address', 'AddressMaintain.MainTable.Column.ConsigneeCompany',
      'AddressMaintain.MainTable.Column.LocalAddress',
      'AddressMaintain.MainTable.Column.EngAddress', 'AddressMaintain.MainTable.Column.Country',
      'AddressMaintain.MainTable.Column.City', 'AddressMaintain.MainTable.Column.AssignmentDistrict',
      'AddressMaintain.MainTable.Column.DeliveryToLocalName','AddressMaintain.MainTable.Column.DeliveryToEngName',
      'AddressMaintain.MainTable.Column.Airport', 'AddressMaintain.MainTable.Column.CreateUser',
      'AddressMaintain.MainTable.Column.CreateDt', 'AddressMaintain.MainTable.Column.UpdateUser',
      'AddressMaintain.MainTable.Column.UpdateDt'];

      return genTableTranslation(this.translateService, fields, dates, fieldSorts, jsons);
  }

  tableDetailTranslation(): any[] {

    const fields: string[] = ['address', 'consigneeCompany', 'updateUser', 'updateDt', 'createUser', 'createDt'];
    const dates: string[] = ['updateDt', 'createDt'];
    const fieldSorts = fields;
    const jsons: string[] = [
      'AddressMaintain.MainTable.Column.Address',
      'AddressMaintain.MainTable.Column.ConsigneeCompany',
      'AddressMaintain.MainTable.Column.UpdateUser',
      'AddressMaintain.MainTable.Column.UpdateDt',
      'AddressMaintain.MainTable.Column.CreateUser',
      'AddressMaintain.MainTable.Column.CreateDt',
    ];

    return genTableTranslation(this.translateService, fields, dates, fieldSorts, jsons);
  }

  setPageSize(event: any): void {
    this.pageInfo.pageSize = event.rows;
  }
}
